import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllStations = async () => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/stations`);
  const stations = await result.json();
  return stations;
};

export default fetchAllStations;
